/**
 * Same rules as Auth0 React `hasAuthParams`: OAuth redirects include state plus either code or error.
 */
const CODE_RE = /[?&](?:connect_)?code=[^&]+/;
const STATE_RE = /[?&]state=[^&]+/;
const ERROR_RE = /[?&]error=[^&]+/;

export const hasAuthRedirectSearchParams = (
  search: string = typeof window !== "undefined" ? window.location.search : ""
): boolean =>
  (CODE_RE.test(search) || ERROR_RE.test(search)) && STATE_RE.test(search);
